import { Flex, Text } from "@suns/design-system";

export function PrintFooter() {
  return (
    <Flex
      justify="center"
      className="fixed bottom-2.5 left-0 hidden w-full text-center print:flex"
    >
      <Text
        className="w-3/5 rounded bg-white px-2 py-1 text-gray-500"
        italic
        size="3xs"
      >
        The information in this document is proprietary and confidential and is
        covered by the confidentiality provisions in the Player 15 Group's
        Handbook. Any unauthorized use, disclosure or copying of this document
        is strictly prohibited.
      </Text>
    </Flex>
  );
}
